<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            path: '/dashboard',
            icon: 'ni ni-tv-2 text-primary'
          }"
        >
        </sidebar-item>

        <!-- <sidebar-item
            :link="{
              name: 'Icons',
              path: '/icons',
              icon: 'ni ni-planet text-primary'
              }"
            >
        </sidebar-item> -->
        <!-- 
        <sidebar-item
              :link="{
                name: 'Maps',
                path: '/maps',
                icon: 'ni ni-pin-3 text-primary'
              }">
        </sidebar-item> -->

       <!-- <sidebar-item
              :link="{
                name: 'User Profile',
                path: '/profile',
                icon: 'ni ni-single-02 text-primary'
                }">
        </sidebar-item> -->

        <sidebar-item
                :link="{
                  name: 'Brands',
                  path: '/brands',
                  icon: 'ni ni-briefcase-24 text-primary'
                }">
        </sidebar-item>

        <sidebar-item
                :link="{
                  name: 'Domains',
                  path: '/domains',
                  icon: 'ni ni-world-2 text-primary'
                }">
        </sidebar-item>

        <sidebar-item
                :link="{
                  name: 'Job Histories',
                  path: '/job_histories',
                  icon: 'ni ni-collection text-primary'
                }">
        </sidebar-item>

        <sidebar-item
                :link="{
                  name: 'Job Groups',
                  path: '/job_groups',
                  icon: 'ni ni-archive-2 text-primary'
                }">
        </sidebar-item>

        <sidebar-item
                :link="{
                  name: 'Job Group Histories',
                  path: '/job_group_histories',
                  icon: 'ni ni-collection text-primary'
                }">
        </sidebar-item>
        <sidebar-item
                  :link="{
                    name:'Location reports',
                    path:'/location_reports',
                    icon:'ni ni-chart-bar-32 text-primary'
                  }">
        </sidebar-item>
        <sidebar-item
                  :link="{
                    name:'Popularity',
                    path:'/popularity',
                    icon:'ni ni-building text-primary'
                  }">
        </sidebar-item>

        <sidebar-item
                  :link="{
                    name: 'Login',
                    path: '/login',
                    icon: 'ni ni-key-25 text-primary'
                  }">
        </sidebar-item>
        <sidebar-item
                  :link="{
                    name: 'Register',
                    path: '/register',
                    icon: 'ni ni-circle-08 text-primary'
                  }">
        </sidebar-item>
        <sidebar-item
                  :link="{
                    name:'Logout',
                    path:'/logout',
                    icon:'ni ni-button-power text-primary'
                  }">
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import DashboardContent from './Content.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      DashboardContent,
      FadeTransition
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      }
    },
    mounted() {
      this.initScrollbar()
    }
  };
</script>

<style lang="scss">

</style>
